import React, { useState, useEffect } from "react";

import {
  Box,
  Typography,
  Grid,
  TextField,
  Paper,
  Button,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  IconButton,
  Divider,
  FormHelperText,
  Tabs,
  Tab,
} from "@mui/material";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import VisibilityIcon from "@mui/icons-material/Visibility";

import { useDispatch, useSelector } from "react-redux";

import { getLowestLevelTask, getProjectsByUserId } from "../../api/project";
import { handleAxiosError } from "../../config/action-config";

import {
  userProjectTable as tableDef,
  employeeTimesheetTable,
} from "../../config/grid-columns-defs";
import ControlledTable from "../../component/ControlledTable";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { AgGridReact } from "ag-grid-react";

import dayjs from "dayjs";

import {
  getEmployeeTimesheet,
  createTimesheet,
  updateTimesheet,
} from "../../api/timesheet";
import { showAlert } from "../../actions/alert";
import BetterControlledTable from "../../component/BetterControlledTable";
import { useNavigate } from "react-router-dom";
import { getExportToExcel } from "../../api/employee";
import download from "downloadjs";
import TabPanel from "../../component/TabPanel";
import {
  getWorkingStatusById,
  getWorkingStatusByUserId,
  inserClockInByUser,
  postWorkingStatus,
} from "../../api/workingStatus";

const { monday, sunday } = getThisWeek(new Date().toJSON().slice(0, 10));

export default function Home() {
  const rowHeight = 38;
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const [totalCount, setTotalCount] = useState(0);

  const [rows, setRows] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);

  const [projectName, setProjectName] = useState("");
  const [projectId, setProjectId] = useState("");
  const [projects, setProjects] = useState([]);
  const navigate = useNavigate();
  let obj = tableDef.find((o) => o.headerName === "Action");
  if (obj === undefined) {
    tableDef.unshift({
      headerName: "Action",
      field: "actions",
      resizable: true,
      wrapText: true,
      autoHeight: true,
      minWidth: 65,
      maxWidth: 70,
      headerClass: "justify-center",
      cellClass: "pmt-ag-cell-font justify-center",
      cellRendererFramework: (params) => (
        <IconButton
          color="info"
          onClick={() => {
            navigate(`/projects/${params.data.project_id}`, { replace: true });
            localStorage.setItem("projectType", params.data.project_type);
          }}
        >
          <VisibilityIcon fontSize="inherit" />
        </IconButton>
      ),
    });
  }

  const getRows = async (numRows, startRow) => {
    return getProjectsByUserId(
      "me",
      { limit: numRows, offset: startRow, sort: "creation_date" },
      user.token
    )
      .then((res) => {
        setTotalCount(parseInt(res.data.total) === 0 ? -1 : res.data.total);
        return res.data.data;
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        return [];
      });
  };
  useEffect(() => {
    projectList();
  }, []);
  const projectList = () => {
    getProjectsByUserId("me", {}, user.token)
      .then((res) => {
        setProjects(res.data.data);
      })
      .catch((err) => handleAxiosError(err, dispatch));
  };
  // async function getRows(limit, offset) {
  //   try {
  //     const { data } = await getProjectsByUserId(
  //       "me",
  //       { limit, offset, sort: "creation_date" },
  //       user.token
  //     );

  //     return {
  //       rows: data.data,
  //       total: data.total,
  //       error: false,
  //     };
  //   } catch (error) {
  //     return { error: true };
  //   } finally {
  //     // setLoading(false);
  //   }
  // }

  const [timesheetGridApi, setTimesheetGridApi] = useState(null);
  const [timesheetColDef, setTimesheetColDef] = useState(
    employeeTimesheetTable
    // formatTimesheetHeaders(employeeTimesheetTable, monday)
  );
  const [timesheetData, setTimesheetData] = useState([]);
  const [timesheetDates, setTimesheetDates] = useState({
    from: monday,
    to: sunday,
  });
  const [timesheetFromFilterDate, setTimesheetFromFilterDate] =
    useState(monday);
  const [timesheetToFilterDate, setTimesheetToFilterDate] = useState(sunday);
  const [selectedTimesheetRow, setSelectedTimesheetRow] = useState(0);
  const [showTimesheetDialog, setShowTimesheetDialog] = useState(false);
  const [timesheetDialogMode, setTimesheetDialogMode] = useState("Create");
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [workingStatusByUserToken, setWorkingStatusByUserToken] =
    useState(false);
  const refreshTable = async () => {
    setTableRefreshCount((prev) => prev + 1);
  };

  const handleTimesheetDateChange = ({ name, value }) => {
    const { monday, sunday } = getThisWeek(value);
    // console.log("timesheeet dates=====", monday, sunday);

    setTimesheetDates({ from: monday, to: sunday });
  };

  const loadTimesheetData = () => {
    getEmployeeTimesheet(
      "me",
      {
        project_id: projectId,
        from: new Date(timesheetFromFilterDate).toJSON(),
        to: new Date(timesheetToFilterDate).toJSON(),
      },
      // timesheetDates,

      user.token
    )
      .then((res) => {
        setTimesheetData(res.data.data);
      })
      .catch((err) => handleAxiosError(err, dispatch));
  };

  // useEffect(() => {
  //   // if at initial postion
  //   if (timesheetDates.from === monday && timesheetDates.to === sunday) return;
  //   const oldColDef = timesheetGridApi.getColumnDefs();
  //   const newTimesheetColDef = formatTimesheetHeaders(
  //     oldColDef,
  //     timesheetDates.from
  //   );
  //   setTimesheetColDef(newTimesheetColDef);
  //   loadTimesheetData();
  // }, [timesheetDates]);
  useEffect(() => {
    // if at initial postion
    if (
      timesheetFromFilterDate === monday &&
      timesheetToFilterDate === sunday
    ) {
      loadTimesheetData();
    } else {
      const oldColDef = timesheetGridApi.getColumnDefs();
      // const newTimesheetColDef = formatTimesheetHeaders(
      //   oldColDef,
      //   timesheetFromFilterDate
      // );
      // console.log("newTimesheetColDef", newTimesheetColDef);
      // setTimesheetColDef(newTimesheetColDef);
      loadTimesheetData();
    }
  }, [timesheetFromFilterDate, timesheetToFilterDate, projectName, projectId]);

  const onTimesheetGridReady = (params) => {
    setTimesheetGridApi(params.api);
    loadTimesheetData();
  };

  const onTimesheetDialogSubmit = async (data) => {
    try {
      let res = {};
      if (timesheetDialogMode === "Create") {
        res = await createTimesheet(
          { ...data, employee_id: user.roleId },
          user.token
        );
      } else {
        res = await updateTimesheet(selectedTimesheetRow, data, user.token);
      }
      loadTimesheetData();
      dispatch(showAlert(res.data.msg));
      setShowTimesheetDialog(false);
      setTimesheetData([]);
      setSelectedTimesheetRow(0);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };
  const getExcelViewerData = () => {
    // if (projectName === "") {
    //   return dispatch(showAlert("Select any input"));
    // }
    return getExportToExcel(
      "me",
      {
        project_id: projectId,
        from: new Date(timesheetFromFilterDate).toJSON(),
        to: new Date(timesheetToFilterDate).toJSON(),
        excel: "y",
      },
      user.token
    )
      .then((res) => {
        if (res) {
          download(
            res.data,
            new Date().toLocaleDateString() + "_timesheet.csv"
          );
        } else {
          alert("Data not found");
        }
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };
  const resetFilterFields = () => {
    setProjectId("");
    setProjectName("");
    setTimesheetFromFilterDate(monday);
    setTimesheetToFilterDate(sunday);
  };

  // working status//
  const getWorkingStatusData = () => {
    getWorkingStatusByUserId(user.token)
      .then((res) => {
        setWorkingStatusByUserToken(res.data.WorkingStatus);
      })
      .catch((err) => handleAxiosError(err, dispatch));
  };
  useEffect(() => {
    if (user?.token) {
      getWorkingStatusData();
    }
    return;
  }, []);
  const onWorkingStatusSubmit = async () => {
    try {
      let res = {};

      res = await inserClockInByUser(user.token);
      dispatch(showAlert(res.data.msg));
      getWorkingStatusData();
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };
  // const [currentTime, setCurrentTime] = useState(new Date());

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     setCurrentTime(new Date());
  //   }, 1000); // Update the time every second

  //   return () => {
  //     clearInterval(intervalId); // Cleanup when the component unmounts
  //   };
  // }, []);
  return (
    <Box className="pmt-container-box">
      <Box className="pmt-title-box">
        {/* <div>
          <h1>Current Time:</h1>
          <p>{currentTime.toLocaleTimeString()}</p>
        </div> */}
        <Box className="typography-title">
          <Typography variant="h5" fontWeight="500" textTransform="capitalize">
            Welcome, {user.firstname} !!
          </Typography>
        </Box>
        {workingStatusByUserToken === false ? (
          <Button
            disabled={/^Trial_User$/i.test(user.role) ? true : false}
            variant="contained"
            style={{ padding: "5px 7px" }}
            onClick={() => {
              onWorkingStatusSubmit();
              // setCreateDialogOpen(true);
            }}
            className="blue-button"
          >
            Working status
          </Button>
        ) : (
          <Typography variant="h5" fontWeight="500" textTransform="capitalize">
            Working Status has been updated for today.
          </Typography>
        )}
      </Box>

      <br />
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabIndex}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          aria-label="basic tabs example"
        >
          <Tab
            label="Your Projects"
            id="simple-tab-0"
            aria-controls="simple-tabpanel-0"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          <Tab
            label="Your Timesheet"
            id="simple-tab-1"
            aria-controls="simple-tabpanel-1"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
        </Tabs>
      </Box>
      <TabPanel value={tabIndex} index={0}>
        <Paper>
          {/* <Typography variant="h6">Your Projects</Typography> */}

          <div className="pmt-controll-table">
            <ControlledTable
              rows={rows}
              columnDefs={tableDef}
              getRows={getRows}
              totalCount={totalCount}
              onChange={setRows}
              onPageNumberChange={setPageNumber}
              pageSize={10}
              pageNumber={pageNumber}
              pagination={true}
              //getRowNodeId={(data) => data?.name || data?.index}
              // height="300px"
            />
          </div>
        </Paper>
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        {/* <Typography variant="h6">Your Timesheet</Typography> */}
        <Paper>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              boxShadow: "0 4px 6px -1px #d0d0d0",
              borderRadius: "6px",
              padding: { sm: "15px 20px", xs: "8px 8px" },
              // background: "#178af4",
              // color: "#101728",
              width: "100%",
            }}
          >
            <Grid
              container
              className="report-filter-box"
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 1, md: 1 }}
            >
              <Grid item lg={2} md={2} sm={4} xs={6}>
                <Button
                  variant="contained"
                  style={{ padding: "5px 7px" }}
                  onClick={() => {
                    setSelectedTimesheetRow(0);
                    setShowTimesheetDialog(true);
                    setTimesheetDialogMode("Create");
                    setTimesheetDates({
                      from: monday,
                      to: sunday,
                    });
                  }}
                  className="blue-button"
                >
                  Add Timesheeet
                </Button>
              </Grid>

              <Grid item lg={2} md={2} sm={4} xs={6}>
                <TextField
                  size="small"
                  label="Projects"
                  value={projectName}
                  variant="outlined"
                  select
                  fullWidth
                  onChange={(e) => {
                    const selectedProjectName = e.target.value;
                    setProjectName(selectedProjectName);
                    const selectedIndex = projects.findIndex(
                      (p) => p.project_name === selectedProjectName
                    );
                    const selectedProject = projects[selectedIndex];
                    setProjectId(selectedProject.project_id);
                  }}
                >
                  <MenuItem value="">Select</MenuItem>
                  {projects?.map((c, i) => (
                    <MenuItem key={i} value={c.project_name}>
                      {c.project_name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item lg={2} md={2} sm={4} xs={6}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    size="small"
                    inputFormat="MM/dd/yyyy"
                    label="Start Date"
                    value={timesheetFromFilterDate}
                    onChange={(newValue) => {
                      setTimesheetFromFilterDate(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField {...params} size="small" fullWidth />
                    )}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item lg={2} md={2} sm={4} xs={6}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    size="small"
                    inputFormat="MM/dd/yyyy"
                    label="End Date"
                    disableFuture
                    shouldDisableDate={disablePrevDates(
                      dayjs(new Date(timesheetFromFilterDate))
                        .subtract(1, "days")
                        .toJSON()
                    )}
                    value={timesheetToFilterDate}
                    onChange={(newValue) => {
                      setTimesheetToFilterDate(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField {...params} size="small" fullWidth />
                    )}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item lg={2} md={2} sm={4} xs={6}>
                <Button
                  className="export-button"
                  style={{ padding: "5px" }}
                  onClick={() => {
                    resetFilterFields();
                  }}
                >
                  Reset
                </Button>
              </Grid>
              <Grid item lg={2} md={2} sm={4} xs={6}>
                <Button
                  disabled={/^Trial_User$/i.test(user.role) ? true : false}
                  className="export-button"
                  style={{ padding: "5px" }}
                  onClick={() => {
                    getExcelViewerData();
                  }}
                >
                  Export to Excel
                </Button>
              </Grid>
              {selectedTimesheetRow ? (
                <Grid item lg={2} md={2} sm={4} xs={6}>
                  <Button
                    variant="contained"
                    style={{ padding: "5px 7px" }}
                    onClick={() => {
                      setShowTimesheetDialog(true);
                      setTimesheetDialogMode("Update");
                    }}
                    className="blue-button"
                  >
                    Edit Selected
                  </Button>
                </Grid>
              ) : (
                <></>
              )}
            </Grid>
          </Box>
          {/* <Box sx={{ display: "flex", columnGap: 1, p: 1 }}>
        
         
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
           
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
          
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
           
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
            <Button
              className="export-button"
              style={{ padding: "5px" }}
              onClick={() => {
                getExcelViewerData();
              }}
            >
              Export to Excel
            </Button>
          </Grid>
        </Box> */}
          {/* <Grid
          container
          spacing={1}
          sx={{ m: "auto", justifyContent: "center", p: 2 }}
        >
          <Grid item xs={12} sm={6} md={6} lg={4}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                inputFormat="MM/dd/yyyy"
                label="Week Start"
                value={timesheetDates.from}
                onChange={(newValue) => {
                  handleTimesheetDateChange({
                    name: "week_start",
                    value: newValue,
                  });
                }}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                inputFormat="MM/dd/yyyy"
                label="Week End"
                value={timesheetDates.to}
                onChange={(newValue) => {
                  handleTimesheetDateChange({
                    name: "week_end",
                    value: newValue,
                  });
                }}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          </Grid>
        </Grid> */}
          <hr className="bg-dark" />
          <div
            className="ag-theme-material pmt-controll-table"
            // style={{ height: "300px" }}
          >
            <AgGridReact
              onGridReady={onTimesheetGridReady}
              // columnDefs={timesheetColDef}
              columnDefs={employeeTimesheetTable}
              rowData={timesheetData}
              rowSelection="single"
              onRowClicked={(params) => {
                if (params.data.approvalstatus === "Approved") {
                  setSelectedTimesheetRow(0);
                } else {
                  setSelectedTimesheetRow(params.data.id);
                  setTimesheetDates({
                    from: params.data.week_start_date,
                    to: params.data.week_end_date,
                  });
                }
              }}
              domLayout="autoHeight"
              rowHeight={rowHeight}
              headerHeight="38"
            />
          </div>
        </Paper>
      </TabPanel>

      {/* <BetterControlledTable
        hasActionButtons={false}
        getTableRows={getRows}
        columns={tableDef}
        perPage={10}
        refreshCounter={tableRefreshCount}
      /> */}

      <br />

      <TimesheetDialog
        open={showTimesheetDialog}
        setOpen={setShowTimesheetDialog}
        timesheetData={timesheetData.find((t) => t.id === selectedTimesheetRow)}
        projects={rows}
        token={user.token}
        onSubmit={onTimesheetDialogSubmit}
        mode={timesheetDialogMode}
        colDef={timesheetColDef}
        timesheetDatesdata={timesheetDates}
        selectedTimesheetRow={selectedTimesheetRow}
      />
    </Box>
  );
}

function TimesheetDialog({
  open,
  setOpen,
  onSubmit,
  timesheetData,
  mode = "Create",
  projects = [],
  token,
  colDef,
  timesheetDatesdata,
  selectedTimesheetRow,
}) {
  const weekDates = getWeekDates(
    timesheetDatesdata.from,
    timesheetDatesdata.to
  );

  const dates = {};
  weekDates.forEach((date, index) => {
    const dayOfWeek = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ][index];
    dates[`${dayOfWeek}Date`] = date.toDateString();
  });

  useEffect(() => {
    setTimesheetDates({
      week_start_date: timesheetDatesdata.from,
      week_end_date: timesheetDatesdata.to,
    });
  }, [timesheetDatesdata]);
  useEffect(() => {
    if (selectedTimesheetRow === 0) {
      setData(emptyData);
    } else {
      const {
        project_id,
        task_id,
        monday_hours,
        mon_notes,
        tuesday_hours,
        tue_notes,
        wednesday_hours,
        wed_notes,
        thursday_hours,
        thu_notes,
        friday_hours,
        fri_notes,
        saturday_hours,
        sat_notes,
        sunday_hours,
        sun_notes,
        notes,
      } = timesheetData;
      setData({
        project_id,
        task_id,
        monday_hours,
        mon_notes,
        tuesday_hours,
        tue_notes,
        wednesday_hours,
        wed_notes,
        thursday_hours,
        thu_notes,
        friday_hours,
        fri_notes,
        saturday_hours,
        sat_notes,
        sunday_hours,
        sun_notes,
        notes,
      });
    }
  }, [selectedTimesheetRow]);
  const [formErrors, setFormErrors] = useState({});
  const { monday, sunday } = getThisWeek(new Date().toJSON().slice(0, 10));
  const [timesheetDates, setTimesheetDates] = useState({
    week_start_date: monday,
    week_end_date: sunday,
  });
  const emptyData = {
    project_id: "",
    task_id: "",
    week_start_date: monday,
    week_end_date: sunday,
    monday_hours: 0,
    mon_notes: "",
    tuesday_hours: 0,
    tue_notes: "",
    wednesday_hours: 0,
    wed_notes: "",
    thursday_hours: 0,
    thu_notes: "",
    friday_hours: 0,
    fri_notes: "",
    saturday_hours: 0,
    sat_notes: "",
    sunday_hours: 0,
    sun_notes: "",
    // notes: "",
  };
  const [data, setData] = useState(emptyData);

  const [dayDateMap, setDayDateMap] = useState({
    monday_hours: "",
    tuesday_hours: "",
    wednesday_hours: "",
    thursday_hours: "",
    friday_hours: "",
    saturday_hours: "",
    sunday_hours: "",
  });
  // useEffect(() => {
  //   // if at initial postion
  //   if (mode !== "Create") {
  //     setDayDateMap(getDayDateMap(colDef));
  //   } else {
  //     const newTimesheetColDef = formatTimesheetHeaders(
  //       colDef,
  //       timesheetDates.week_start_date
  //     );
  //     setDayDateMap(getDayDateMap(newTimesheetColDef));
  //   }
  // }, [timesheetDates]);
  useEffect(() => {
    setDayDateMap(getDayDateMap(colDef));
  }, [colDef]);

  useEffect(() => {
    if (timesheetData?.project_id) {
      const { week_start_date, week_end_date } = timesheetData;
      setTimesheetDates({
        week_start_date: week_start_date,
        week_end_date: week_end_date,
      });
      const {
        project_id,
        task_id,
        monday_hours,
        mon_notes,
        tuesday_hours,
        tue_notes,
        wednesday_hours,
        wed_notes,
        thursday_hours,
        thu_notes,
        friday_hours,
        fri_notes,
        saturday_hours,
        sat_notes,
        sunday_hours,
        sun_notes,
        notes,
      } = timesheetData;
      setData({
        project_id,
        task_id,
        monday_hours,
        mon_notes,
        tuesday_hours,
        tue_notes,
        wednesday_hours,
        wed_notes,
        thursday_hours,
        thu_notes,
        friday_hours,
        fri_notes,
        saturday_hours,
        sat_notes,
        sunday_hours,
        sun_notes,
        notes,
      });
    }
  }, [timesheetData?.project_id, selectedTimesheetRow]);
  const dispatch = useDispatch();
  const [taskList, setTaskList] = useState([]);
  const [taskDisabled, setTaskDisabled] = useState(true);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };
  const handleChangeStartEnd = ({ name, value }) => {
    const { monday, sunday } = getThisWeek(value);
    setTimesheetDates({ week_start_date: monday, week_end_date: sunday });
  };

  useEffect(() => {
    if (!data.project_id) return;
    setTaskDisabled(true);

    const project = projects.find((p) => p.project_id === data.project_id);
    if (!project) {
      // Project with the given project_id was not found
      // Handle the situation accordingly
      return;
    }

    const isPmForProject = project.project_role === "PM";

    getLowestLevelTask(data.project_id, token, !isPmForProject)
      .then((res) => {
        setTaskList(res.data.data);
        setTaskDisabled(false);
      })
      .catch((err) => handleAxiosError(err, dispatch));
  }, [data.project_id]);

  // const submit = (e) => {
  //   e.preventDefault();
  //   let combineData = {
  //     ...data,
  //     week_start_date: timesheetDates.week_start_date,
  //     week_end_date: timesheetDates.week_end_date,
  //   };

  //   onSubmit(combineData).then(() => {
  //     setData(emptyData);
  //   });
  // };
  const submit = (e) => {
    e.preventDefault();

    // Perform validation checks
    const errors = {};
    if (!data.project_id) {
      errors.project_id = "Project is required";
    }
    if (!data.task_id) {
      errors.task_id = "Task is required";
    }
    // Add more validation checks for other fields as needed

    // Update the formErrors state
    setFormErrors(errors);

    // Check if there are any validation errors
    if (Object.keys(errors).length === 0) {
      // No errors, submit the form
      let combineData = {
        ...data,
        week_start_date: timesheetDates.week_start_date,
        week_end_date: timesheetDates.week_end_date,
      };

      onSubmit(combineData).then(() => {
        setData(emptyData);
      });
    }
  };
  const user = useSelector((state) => state.user);
  return (
    <Dialog
      open={open}
      onClose={() => {
        //  setOpen(true);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box component="form" onSubmit={submit}>
        <DialogTitle
          id="alert-dialog-title"
          sx={{ textTransform: "capitalize" }}
        >
          {mode} Timesheet
        </DialogTitle>
        <DialogContent>
          <Grid container width={500} spacing={1} py={1}>
            <Grid item xs={12} sm={6} md={6} className="m-tb-10">
              <FormControl
                fullWidth
                required
                error={Boolean(formErrors.project_id)}
              >
                <InputLabel id="demo-simple-select-label-pro">
                  Project
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label-pro"
                  id="demo-simple-select-pro"
                  value={data.project_id}
                  label="Project"
                  name="project_id"
                  disabled={mode !== "Create" ? true : false}
                  // disabled={!Boolean(projects.length)}
                  onChange={handleChange}
                  className={formErrors.project_id ? "error" : ""}
                >
                  {projects.map((p, i) => (
                    <MenuItem key={i} value={p.project_id}>
                      {p.project_name}
                    </MenuItem>
                  ))}
                </Select>
                {formErrors.project_id && (
                  <FormHelperText>{formErrors.project_id}</FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-tb-10">
              <FormControl
                fullWidth
                required
                error={Boolean(formErrors.task_id)}
              >
                <InputLabel id="demo-simple-select-label-taks">Task</InputLabel>
                <Select
                  labelId="demo-simple-select-label-task"
                  id="demo-simple-select-task"
                  value={data.task_id}
                  label="Task"
                  name="task_id"
                  disabled={mode !== "Create" ? true : false}
                  // disabled={!Boolean(taskList.length)}
                  onChange={handleChange}
                  className={formErrors.task_id ? "error" : ""}
                >
                  {taskList.map((t, i) => (
                    <MenuItem key={i} value={t.id}>
                      {t.task_code} - {t.task_name}
                    </MenuItem>
                  ))}
                </Select>
                {formErrors.task_id && (
                  <FormHelperText>{formErrors.task_id}</FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-tb-10">
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="MM/dd/yyyy"
                  label="Week Start Date"
                  value={timesheetDates.week_start_date}
                  onChange={(newValue) => {
                    handleChangeStartEnd({
                      name: "week_start_date",
                      value: newValue,
                    });
                  }}
                  // disabled
                  disabled={mode !== "Create" ? true : false}
                  disableFuture
                  renderInput={(params) => (
                    <TextField required {...params} fullWidth />
                  )}
                  error={Boolean(formErrors.week_start_date)}
                  helperText={formErrors.week_start_date}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-tb-10">
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="MM/dd/yyyy"
                  label="Week End Date"
                  value={timesheetDates.week_end_date}
                  // disabled
                  disabled={mode !== "Create" ? true : false}
                  disableFuture
                  onChange={(newValue) => {
                    handleChangeStartEnd({
                      name: "week_end_date",
                      value: newValue,
                    });
                  }}
                  renderInput={(params) => (
                    <TextField required {...params} fullWidth />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-tb-10">
              <TextField
                type="number"
                inputProps={{ max: 12 }}
                onChange={handleChange}
                value={data.monday_hours}
                label={dayDateMap["monday_hours"]}
                name="monday_hours"
                fullWidth
                disabled={
                  mode === "Create" ? false : isFutureDate(dates.MondayDate)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-tb-10">
              <TextField
                type="number"
                inputProps={{ max: 12 }}
                onChange={handleChange}
                value={data.tuesday_hours}
                label={dayDateMap["tuesday_hours"]}
                name="tuesday_hours"
                fullWidth
                disabled={
                  mode === "Create" ? false : isFutureDate(dates.TuesdayDate)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-tb-10">
              <TextField
                multiline
                rows={4} // adjust this value to increase or decrease the number of rows
                rowsMax={10}
                inputProps={{ max: 12 }}
                onChange={handleChange}
                value={data.mon_notes}
                label={dayDateMap["monday_hours"] + " Notes"}
                name="mon_notes"
                fullWidth
                disabled={
                  mode === "Create" ? false : isFutureDate(dates.MondayDate)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-tb-10">
              <TextField
                multiline
                rows={4} // adjust this value to increase or decrease the number of rows
                rowsMax={10}
                inputProps={{ max: 12 }}
                onChange={handleChange}
                value={data.tue_notes}
                label={dayDateMap["tuesday_hours"] + " Notes"}
                name="tue_notes"
                fullWidth
                disabled={
                  mode === "Create" ? false : isFutureDate(dates.TuesdayDate)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-tb-10">
              <TextField
                type="number"
                inputProps={{ max: 12 }}
                onChange={handleChange}
                value={data.wednesday_hours}
                label={dayDateMap["wednesday_hours"]}
                name="wednesday_hours"
                fullWidth
                disabled={
                  mode === "Create" ? false : isFutureDate(dates.WednesdayDate)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-tb-10">
              <TextField
                type="number"
                inputProps={{ max: 12 }}
                onChange={handleChange}
                value={data.thursday_hours}
                label={dayDateMap["thursday_hours"]}
                name="thursday_hours"
                fullWidth
                disabled={
                  mode === "Create" ? false : isFutureDate(dates.ThursdayDate)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-tb-10">
              <TextField
                multiline
                rows={4} // adjust this value to increase or decrease the number of rows
                rowsMax={10}
                inputProps={{ max: 12 }}
                onChange={handleChange}
                value={data.wed_notes}
                label={dayDateMap["wednesday_hours"] + " Notes"}
                name="wed_notes"
                fullWidth
                disabled={
                  mode === "Create" ? false : isFutureDate(dates.WednesdayDate)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-tb-10">
              <TextField
                multiline
                rows={4} // adjust this value to increase or decrease the number of rows
                rowsMax={10}
                inputProps={{ max: 12 }}
                onChange={handleChange}
                value={data.thu_notes}
                label={dayDateMap["thursday_hours"] + " Notes"}
                name="thu_notes"
                fullWidth
                disabled={
                  mode === "Create" ? false : isFutureDate(dates.ThursdayDate)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-tb-10">
              <TextField
                type="number"
                inputProps={{ max: 12 }}
                onChange={handleChange}
                value={data.friday_hours}
                label={dayDateMap["friday_hours"]}
                name="friday_hours"
                fullWidth
                disabled={
                  mode === "Create" ? false : isFutureDate(dates.FridayDate)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-tb-10">
              <TextField
                type="number"
                inputProps={{ max: 12 }}
                onChange={handleChange}
                value={data.saturday_hours}
                label={dayDateMap["saturday_hours"]}
                name="saturday_hours"
                fullWidth
                disabled={
                  mode === "Create" ? false : isFutureDate(dates.SaturdayDate)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-tb-10">
              <TextField
                multiline
                rows={4} // adjust this value to increase or decrease the number of rows
                rowsMax={10}
                inputProps={{ max: 12 }}
                onChange={handleChange}
                value={data.fri_notes}
                label={dayDateMap["friday_hours"] + " Notes"}
                name="fri_notes"
                fullWidth
                disabled={
                  mode === "Create" ? false : isFutureDate(dates.FridayDate)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-tb-10">
              <TextField
                multiline
                rows={4} // adjust this value to increase or decrease the number of rows
                rowsMax={10}
                inputProps={{ max: 12 }}
                onChange={handleChange}
                value={data.sat_notes}
                label={dayDateMap["saturday_hours"] + " Notes"}
                name="sat_notes"
                fullWidth
                disabled={
                  mode === "Create" ? false : isFutureDate(dates.SaturdayDate)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-tb-10">
              <TextField
                type="number"
                inputProps={{ max: 12 }}
                onChange={handleChange}
                value={data.sunday_hours}
                label={dayDateMap["sunday_hours"]}
                name="sunday_hours"
                fullWidth
                disabled={
                  mode === "Create" ? false : isFutureDate(dates.SundayDate)
                }
              />
            </Grid>
            <Divider
              orientation="vertical"
              flexItem
              sx={{ alignSelf: "baseline !important" }}
            />
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                multiline
                rows={4} // adjust this value to increase or decrease the number of rows
                rowsMax={10}
                inputProps={{ max: 12 }}
                onChange={handleChange}
                value={data.sun_notes}
                label={dayDateMap["sunday_hours"] + " Notes"}
                name="sun_notes"
                fullWidth
                disabled={
                  mode === "Create" ? false : isFutureDate(dates.SundayDate)
                }
              />
            </Grid>
            {/* <Grid item xs={12} md={12}>
              <TextField
                type="text"
                inputProps={{ max: 12 }}
                onChange={handleChange}
                value={data.notes}
                name="notes"
                label="Notes"
                fullWidth
                required
              />
            </Grid> */}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
              // if (selectedTimesheetRow === 0) {
              //   setData(emptyData);
              // }
              // return;
              // setData(emptyData);
            }}
            className="cancel-button"
          >
            Cancel
          </Button>
          <Button
            disabled={/^Trial_User$/i.test(user.role) ? true : false}
            type="submit"
            className="blue-button"
          >
            {mode}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}

function getThisWeek(date) {
  const utcOffset = dayjs(date).utcOffset();
  const localDate = dayjs(date).add(utcOffset, "minute");
  const dayOfWeek = dayjs(localDate).add(utcOffset, "minute").get("day");

  let thisMonday = dayjs(localDate).subtract(dayOfWeek - 1, "days");
  if (thisMonday.isAfter(localDate)) {
    thisMonday = dayjs(thisMonday).subtract(7, "day");
  }
  const thisSunday = dayjs(thisMonday).add(6, "days");

  return {
    monday: thisMonday.toJSON(),
    sunday: thisSunday.toJSON(),
  };
}

function getDayDateMap(colDef) {
  let map = {};
  colDef.forEach((c) => {
    if (/_hours/.test(c.field)) {
      map[c.field] = c.headerName;
    }
  });

  return map;
}

let dayMap = {
  monday_hours: 0,
  tuesday_hours: 1,
  wednesday_hours: 2,
  thursday_hours: 3,
  friday_hours: 4,
  saturday_hours: 5,
  sunday_hours: 6,
};
function formatTimesheetHeaders(data = [], start) {
  let formatted = data.map((d, i) => {
    if (/_hours$/.test(d.field)) {
      d.headerName = dayjs(start)
        .add(dayMap[d.field], "day")
        .format("MM/DD/YYYY");
      return d;
    }
    return d;
  });

  return formatted;
}
function isFutureDate(dateString) {
  // Create a new Date object using the provided date string
  const date = new Date(dateString);

  // Get the current date
  const currentDate = new Date();

  // Compare the dates
  if (date > currentDate) {
    return true;
  } else {
    return false;
  }
}
function isFutureDateForSatSun(dateStr) {
  // Get the current date
  var currentDate = new Date();

  // Set the next day by adding 1 to the current date
  var nextDay = new Date(currentDate);
  nextDay.setDate(currentDate.getDate() + 1);

  // Check if the next day is a Saturday (6) or Sunday (0)
  if (nextDay.getDay() === 6 || nextDay.getDay() === 0) {
    return false;
  } else {
    return true;
  }
}
function disablePrevDates(startDate) {
  const startSeconds = Date.parse(startDate);
  return (date) => {
    return Date.parse(date) < startSeconds;
  };
}
const isFutureWeekDay = (weekDay) => {
  const currentDate = new Date();
  const currentDay = currentDate.getDay(); // 0 (Sunday) to 6 (Saturday)
  const weekDays = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];
  const selectedDay = weekDays.indexOf(weekDay.toLowerCase());

  // Compare the selected day with the current day
  if (selectedDay > currentDay) {
    return true; // Selected day is in the future or the same as the current day
  }

  return false; // Selected day is in the past
};
function getDatesInRange(startDate, endDate) {
  const dates = [];
  const current = new Date(startDate);

  while (current <= endDate) {
    dates.push(new Date(current));
    current.setDate(current.getDate() + 1);
  }

  return dates;
}

function getWeekDates(weekStart, weekEnd) {
  const startDateParts = weekStart.split("-");
  const endDateParts = weekEnd.split("-");
  const startMonth = parseInt(startDateParts[0]) - 1; // Months are zero-based in JavaScript
  const startDay = parseInt(startDateParts[1]);
  const startYear = 2000 + parseInt(startDateParts[2]);

  const endMonth = parseInt(endDateParts[0]) - 1;
  const endDay = parseInt(endDateParts[1]);
  const endYear = 2000 + parseInt(endDateParts[2]);

  const startDate = new Date(startYear, startMonth, startDay);
  const endDate = new Date(endYear, endMonth, endDay);

  const datesInRange = getDatesInRange(startDate, endDate);
  return datesInRange;
}
